<template>
  <div class="contact">
    <div class="change change1" @mouseenter="change(1)" @mouseleave="change(2)">
      <img src="../assets/images/marshalling1.png" alt="" />
      <div class="phone">400-180-1219</div>
    </div>
    <div class="change" @mouseenter="change2(1)" @mouseleave="change2(2)">
      <img src="../assets/images/marshalling2.png" alt="" />
      <div class="phone2">business@aijiehu.cn</div>
    </div>
    <div class="change">
      <div @click="send(5)">
        <img src="../assets/images/marshalling3.png" alt="" />
      </div>
    </div>
    <div class="change">
      <div @click="send(4)">
        <img src="../assets/images/marshalling4.png" alt="" />
      </div>
    </div>
    <div class="change" @mouseenter="change3(1)" @mouseleave="change3(2)">
      <img src="../assets/images/marshalling5.png" alt="" />
      <div class="phone3"><img src="../assets/images/WeChat.png" alt="" /></div>
    </div>
    <div class="change" @mouseenter="change4(1)" @mouseleave="change4(2)">
      <img src="../assets/images/marshalling6.png" alt="" />
      <div class="phone4">
        <img src="../assets/images/microBlogs.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    send(num) {
      if (num == 5) {
        this.$router.push("/site");
      } else if (num == 4) {
        this.$router.push("/join");
      }
    },
    change(num) {
      var text = document.querySelector(".phone");
      if (num == 1) {
        text.style.cssText =
          "color :#fff;  transform: translateX(-202px); background-color: #f59903 ; font-size: 20px; display:block;width:200px;border-right: 1px solid #fff;font-weight: bold;";
      } else {
        text.style.cssText = "right: 0px;font-size: 0px; display:none";
      }
    },
    change2(num) {
      var text2 = document.querySelector(".phone2");
      if (num == 1) {
        text2.style.cssText =
          "color :#fff;  transform: translateX(-202px); background-color: #f59903 ; font-size: 20px; display:block;width:200px;border-right: 1px solid #fff;font-weight: bold;";
      } else {
        text2.style.cssText = "right: 0px;font-size: 0px; display:none";
      }
    },
    change3(num) {
      var text3 = document.querySelector(".phone3");
      if (num == 1) {
        text3.style.cssText =
          " transform: translateX(-202px); background-color: #f59903 ; display:block;width:200px;border-right: 1px solid #fff;";
      } else {
        text3.style.cssText = " display:none";
      }
    },
    change4(num) {
      var text4 = document.querySelector(".phone4");
      if (num == 1) {
        text4.style.cssText =
          "  transform: translateX(-202px); display:block;width:200px; background-color: #f59903 ;border-right: 1px solid #fff;";
      } else {
        text4.style.cssText = " display:none";
      }
    }
  }
};
</script>
<style scoped>
.contact {
  width: 90px;
  height: 552px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.change {
  background-color: #f59903;
  width: 90px;
  height: 92px;
  border-bottom: 1px solid #fff;
  line-height: 118px;
  position: relative;
}
.contact div:last-child {
  border-bottom: 1px solid transparent;
}
.contact img {
  width: 35px;
  height: 32px;
  cursor: pointer;
}
.phone {
  height: 92px;
  position: absolute;
  top: 0;
  line-height: 92px;
  font-size: 20px;
  display: none;
}
.phone2 {
  height: 92px;
  position: absolute;
  top: 0;
  line-height: 92px;
  font-size: 20px;
  display: none;
}
.phone3 {
  height: 184px;
  position: absolute;
  top: 0;
  font-size: 20px;
  display: none;
}
.phone3 img,
.phone4 img {
  width: 160px;
  height: 160px;
  margin-top: 12px;
}
.phone4 {
  height: 184px;
  position: absolute;
  top: -92px;
  font-size: 20px;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue